<template>
  <div class="room-admin-special-item-box">
    <div
      v-if="room.avatar"
      class="room-avatar avatar-single avatar-single--circle avatar-single--small"
      :style="{ 'background-image': `url('${room.avatar}?p=tiny')` }"
    >
      <div class="avatar-single__online-status d-none d-md-block"></div>
    </div>
    <div class="room-name-container">
      <div class="room-name text-ellipsis">
        {{ room.roomName }}
        <div class="state-circle d-inline-block d-md-none state-online dot-online"></div>
      </div>
      <div
        v-if="room.lastMessage"
      >
        <FormatMessage
          :content="room.lastMessage.content"
          :deleted="!!room.lastMessage.deleted"
          :formatLinks="false"
          :textFormatting="true"
          :singleLine="true"
        ></FormatMessage>
        <span class="room-name-pill" v-if="room.pills" :class="room.pills.type">{{ room.pills.text }}</span>
      </div>
    </div>
    <div v-if="room.lastMessage && room.lastMessage.admin.delete_at" class="counter text-center text-bold">
      <div>Countdown</div>
      <CountdownComponent :countdown="room.lastMessage.admin.delete_at" @seconds="seconds = $event"></CountdownComponent>
    </div>
    <div v-else-if="room.lastMessage.admin.type === 'user'" class="delete">
      <span class="fa fa-times fa-2x ml-xl-3" @click.stop="deleteAction"></span>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import FormatMessage from '../../../packages/vue-advanced-chat/src/ChatWindow/FormatMessage';
import CountdownComponent from '../Ui/CountdownComponent.vue';

export default {
  name: 'RoomAdminItem',
  components: { CountdownComponent, FormatMessage },
  props: {
    room: {},
  },
  data() {
    return {
      seconds: null,
    };
  },
  computed: {},
  watch: {
    seconds: function (newVal) {
      if (newVal === null) {
        return;
      }

      if (newVal < 1) {
        this.deleteAction();
      }
    }
  },
  methods: {
    deleteAction() {
      axios
        .post(`/ajax/chat2/rooms/${this.room.id}/admin-messages/${this.room.lastMessage.admin.m_id}/delete`)
        .then(() => {
          this.$eventHub.$emit('ChatRefreshRoom', this.room.id);
        });
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss">
@import "../../../../sass/viluu/_variables";
@import '../../../../sass/common/base/_base-mixin.scss';

.room-admin-special-item-box {
  flex-grow: 1;
  margin-left: -10px;
  margin-right: -10px;
  display: grid;
  background: linear-gradient(90deg, #c74079 0%, #ec7516 80%);
  border-radius: 15px;
  padding: 8px 10px 8px 8px;
  grid-template-rows: auto;
  grid-template-columns: auto 1fr auto;
  min-width: 0;

  @include phone {
    padding: 3px 23px 3px 10px;
    border-radius: 40px;
  }

  > * {
    color: white !important;
  }

  .room-avatar {
    grid-row: 1 / span 2;
    flex-shrink: 0;
    margin: auto 0.8rem auto 0;
    width: 3.7rem;
    height: 3.7rem;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #ddd;
    margin-right: 25px;
    border-radius: 50%;

    @include phone {
      margin-right: 20px;
    }
  }

  .room-name-container {
    padding: 0;
    height: min-content;
    font-size: 14px;
    line-height: 1.2;

    @include phone {
      height: 100%;
      padding: 6px 0;
    }
  }

  .room-name {
    font-weight: bold;
  }

  .dot-online {
    height: 15px;
    width: 15px;
    vertical-align: unset;
  }

  .room-name-pill {
    display: inline-block;
    padding: .1rem .4rem;
    font-size: .7rem;
    background-color: #c63e7c;
    border-radius: 15px;
    margin: 2px 0;

    @include phone {
      margin: 0;
    }
  }

  .counter {
    line-height: 1.1;
    font-size: 14px;
    grid-column: 2; 
    margin-right: auto;

    @include phone {
      display: block;
      grid-column: initial;
      align-self: center;
    }
  }

  .delete {
    font-size: 12px;
    padding: 5px;
    grid-row: span 2;
    justify-self: right; /* center horizontally */
    align-self: center; /* center vertically */

    span {
      margin-left: 0 !important;
    }
  }
}
</style>